// extracted by mini-css-extract-plugin
module.exports = {"label":"src-components-FormTasksView-styles___label","bold":"src-components-FormTasksView-styles___bold","viewMainTask":"src-components-FormTasksView-styles___viewMainTask"};